import React from 'react';
import PropTypes from 'prop-types';

import Pic1 from '../../InstallImages/Inverters/SolarEdge';

const seCommPV = <a href="https://www.solaredge.com/sites/default/files/se-system-owner-brochure_na.pdf" rel="noopener noreferrer" target="_blank">Optimizing Commercial PV Systems</a>;

const seCommPV2 = <a href="https://www.solaredge.com/sites/default/files/se_environmental_conditions_brochure_na.pdf" rel="noopener noreferrer" target="_blank">Robust for Tought Environments</a>;

const seResiPV = <a href="https://www.solaredge.com/sites/default/files/se-homeowners-brochure-na.pdf" rel="noopener noreferrer" target="_blank"> Power Home Your with SolarEdge</a>;

const Inverter = ({ terms }) => (
    <div>
        <div className="col span-1-of-2">

            <Pic1 />
        </div>
        <div className="col span-1-of-2">

            <p className="specsText">SolarEdge enables more energy generation from each solar module by mitigating power losses that result from mismatch between modules. With SolarEdge, weaker modules do not affect the performance of strong ones. The SolarEdge system is future proofed against potential risks that could cause decreased lifetime energy production.
            </p>
            <p className="specsText">Use the SolarEdge monitoring platform to gain module-level insights into your PV system, ensuring that it is performing to the best of its ability at all times.
            </p>
            <p className="specsText">Compliant with the most advanced safety standards, SolarEdge’s SafeDC™ feature is designed to de-energize the solar array to a safe voltage whenever the inverter or grid is shutdown, protecting your property as well as installers, electricians, and firefighters.</p>
            <ul>
                {terms.resiToggle ?
                    <li className="specsText">{seResiPV}</li>
                    :
                    <div>
                        <li className="specsText">{seCommPV}</li>
                        <li className="specsText">{seCommPV2}</li>
                    </div>
                }
            </ul>
        </div>
    </div>
);

Inverter.propTypes = {
    terms: PropTypes.object.isRequired,
};

export default Inverter;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Inverters/solaredge.js